export function convertHexToRgba(hex: string, alpha: number): string {
  const { r, g, b } = convertHexToRgb(hex)

  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

export function convertHexToRgb(hex: string) {
  let normalizedHex = hex.replace('#', '')

  if (normalizedHex.length === 3) {
    normalizedHex = normalizedHex.split('').map(c => c + c).join('')
  }

  const bigint = parseInt(normalizedHex, 16)

  return {
    r: (bigint >> 16) & 255,
    g: (bigint >> 8) & 255,
    b: bigint & 255
  }
}

export function convertHslToHex(hue: number, saturation: number, lightness: number): string {
  saturation /= 100
  lightness /= 100
  const k = (n: number) => (n + hue / 30) % 12
  const a = saturation * Math.min(lightness, 1 - lightness)
  const f = (n: number) =>
    Math.round((lightness - a * Math.max(-1, Math.min(k(n) - 3, 9 - k(n), 1))) * 255)
      .toString(16)
      .padStart(2, '0')

  return `#${f(0)}${f(8)}${f(4)}`
}

export function generateRainbowColorsInHsl(s: number = 70, l: number = 50): string[] {
  // red, orange, yellow, green, blue, indigo, violet
  const rainbowHues = [0, 30, 60, 120, 180, 240, 270]
  return rainbowHues.map(hue => convertHslToHex(hue, s, l))
}
